import React, { useContext } from "react";
import PropTypes from "prop-types";
import { MobileContext } from "components/common";
import PaymentMethodRadioItem from "./PaymentMethodRadioItem";
import RadioButtons from "./RadioButtons";

const PaymentMethodsRadioButtons = ({
  paymentMethods = [],
  didSelect,
  handleRemove,
  handleRelink,
  className,
  disabled,
  allowRemoveForIds = [],
  ...rest
}) => {
  const { isMobile } = useContext(MobileContext);
  const decorator = () => (
    <span
      className="tooltip ml-2 text-orange-400 text-sm cursor-pointer "
      style={{ borderBottom: 0 }}
    >
      <i className="fas fa-exclamation-triangle" />
      <span
        className="tooltiptext2 text-sm border"
        style={{ left: isMobile ? -150 : -83 }}
      >
        Your default payment method cannot be the same as your SmartPay payment
        method
      </span>
    </span>
  );
  return (
    <RadioButtons
      elements={paymentMethods}
      component={(element) => (
        <PaymentMethodRadioItem
          {...element}
          key={element.element.id}
          allowRemove={allowRemoveForIds.includes(element.element.id)}
          handleRemove={handleRemove}
          showRelink={element.element.unlinked}
          handleRelink={() =>
            handleRelink(element.element.relink_id, element.element.aggregator)
          }
          decorator={element.element.isAlreadySecondary && decorator}
        />
      )}
      didSelect={didSelect}
      className={className}
      disabled={disabled}
      {...rest}
    />
  );
};

PaymentMethodsRadioButtons.propTypes = {
  paymentMethods: PropTypes.array.isRequired,
  didSelect: PropTypes.func,
  handleRemove: PropTypes.func,
  handleRelink: PropTypes.func,
  disabled: PropTypes.bool,
  allowRemoveForIds: PropTypes.array,
};

PaymentMethodsRadioButtons.defaultProps = {
  didSelect: () => {},
  handleRemove: () => {},
  handleRelink: () => {},
  disabled: false,
};

export default PaymentMethodsRadioButtons;
